import { render, staticRenderFns } from "./CustomDomains.vue?vue&type=template&id=03aee8b8"
import script from "./CustomDomains.vue?vue&type=script&lang=js"
export * from "./CustomDomains.vue?vue&type=script&lang=js"
import style0 from "./CustomDomains.vue?vue&type=style&index=0&id=03aee8b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports